import { Account } from '@/common/types'

export enum ClientTab {
    ACTIVE = 'active',
    IN_PROGRESS = 'in_progress',
}

export enum ClientStatus {
    KYC_IN_PROGRESS = 'kyc_in_progress',
    CONFIRMATION_FAILED = 'confirmation_failed',
    CLIENT_CONFIRMATION = 'client_confirmation',
    ACCOUNT_PROCESSING = 'account_processing',
}

export enum StatusCategory {
    ACTION_REQUIRED = 'action_required',
    IN_PROGRESS = 'in_progress',
}

export type GroupedClients = {
    category: StatusCategory
    categoryLabel: string
    count: number
    clients: Account[]
}
